export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9698.c5be03d8.jpg";